import 'isomorphic-fetch';
import * as R from 'ramda';
import isAbsoluteUrl from 'ha/utils/isAbsoluteUrl';

export default class FetchClient {
  private baseUrl: string;
  private options: RequestInit;

  constructor(url: string, options?: RequestInit) {
    this.baseUrl = url;
    this.options = { credentials: 'include', ...options };
  }

  fetch(url: string, options?: RequestInit) {
    return fetch(
      isAbsoluteUrl(url) ? url : `${this.baseUrl}${url}`,
      R.mergeDeepRight(this.options, options || {}),
    );
  }
}
